/**
 * ProductDetailMenu Constants
 * Menü ile ilgili sabit değerler
 */

export class MenuConstants {
  // Sticky positioning
  static readonly STICKY_TOP_OFFSET = 24; // top-6 = 24px (Tailwind)
  
  // Menu dimensions
  static readonly DEFAULT_MENU_HEIGHT = 80; // px
  
  // Scroll offsets
  static readonly SCROLL_OFFSET = 120; // px - Ekstra scroll offset (menü aktif olma için)
  static readonly SCROLL_THRESHOLD_EXTRA = 120; // px - Threshold için ekstra offset
  
  // Animation delays
  static readonly HASH_SCROLL_DELAY = 100; // ms - Hash scroll için bekleme süresi
  
  // Spring animation config
  static readonly SPRING_STIFFNESS = 300;
  static readonly SPRING_DAMPING = 30;
  
  // Accessibility
  static readonly MENU_ARIA_LABEL = "Product detail navigation menu";

  /** Yatay kaydırılabilir menü; overflow-y-visible ile dropdown kesilmez */
  static readonly SCROLL_CONTAINER_CLASS = "overflow-x-auto overflow-y-visible scroll-smooth w-full [scrollbar-gutter:stable] [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-track]:rounded [&::-webkit-scrollbar-thumb]:rounded [&::-webkit-scrollbar-thumb]:bg-gray-200 [&::-webkit-scrollbar-thumb]:hover:bg-gray-300";
  
  /**
   * Toplam scroll offset hesaplama
   * @param menuHeight Menü yüksekliği
   * @returns Toplam offset değeri
   */
  static calculateTotalOffset(menuHeight: number = this.DEFAULT_MENU_HEIGHT): number {
    return menuHeight + this.STICKY_TOP_OFFSET + this.SCROLL_OFFSET;
  }
  
  /**
   * Scroll threshold hesaplama
   * @param menuHeight Menü yüksekliği
   * @returns Threshold değeri
   */
  static calculateThreshold(menuHeight: number = this.DEFAULT_MENU_HEIGHT): number {
    return menuHeight + this.STICKY_TOP_OFFSET + this.SCROLL_THRESHOLD_EXTRA;
  }
}

